import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  footer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: designTokens.spacing[2],
    padding: `${designTokens.spacing[4]} ${designTokens.spacing[3]} ${designTokens.spacing[3]}`,
    borderTop: `1px solid ${designTokens.neutral[200]}`,
    backgroundColor: designTokens.neutral.white,
  },
});
